import script from "./ThresholdSettingsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ThresholdSettingsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ThresholdSettingsComponent.vue?vue&type=style&index=0&id=0d1df60c&scoped=true&lang=css"

import exportComponent from "C:\\www\\mutual-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d1df60c"]])

export default __exports__